// Copyright © 2021 Move Closer
export * from './ArticleSocials';
